import React, { useState, useRef, useCallback, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
const ImageCropper = ({
  uploadedImage, // defaultImages without uploading img
  onCropComplete, // callback function
  renderCustom, // jsx code to render custom
  isRenderCustom = false, // bolean
  fileUploaded, // callback function when file is uploaded this
  resetValue,
  disabled = false, // disbale field
  needCrop = true,
  handleGetFormData = () => {},
}) => {
  const [imageSrc, setImageSrc] = useState(uploadedImage);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [crop, setCrop] = useState({ unit: "%", width: 100, height: 100 });
  const [cropStarted, setCropStarted] = useState(false);
  const imgRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setImageSrc(null);
  }, [resetValue]);

  useEffect(() => {
    setTimeout(() => {
      setErrorMsg("");
    }, 2000);
  }, [errorMsg]);

  useEffect(() => {
    if (uploadedImage !== "") {
      setImageSrc(uploadedImage);
      setIsDisabled(!isDisabled);
    }
    getCroppedImage();
  }, [uploadedImage]);

  const handleDivClick = () => {
    if (!isDisabled) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
    if (file && allowedTypes.includes(file.type)) {
      setIsDisabled(true);

      const objectUrl = URL.createObjectURL(file);
      fileUploaded(objectUrl);

      const reader = new FileReader();
      reader.onload = () => setImageSrc(reader.result);
      reader.readAsDataURL(file);

      setErrorMsg("");
    } else {
      setErrorMsg("Please upload a valid image (.png, .jpeg, .jpg, .gif)");
    }
    handleGetFormData(file);
    setIsDisabled(false);
  };

  const onImageLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  const getCroppedImage = () => {
    if (!crop || !imgRef.current) return;
    // setCropStarted(false);
    const canvas = document.createElement("canvas");
    const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
    const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
    const ctx = canvas.getContext("2d");

    const pixelCrop = {
      x: crop.x * scaleX,
      y: crop.y * scaleY,
      width: crop.width * scaleX,
      height: crop.height * scaleY,
    };

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
      imgRef.current,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], "cropped-image.jpg", {
          type: "image/jpeg",
        });
        const url = URL.createObjectURL(file);
        if (onCropComplete) {
          onCropComplete(blob, url);
        }

        if (fileUploaded) {
          fileUploaded(url);
          handleGetFormData(file);
        }
      }
    }, "image/jpeg");
  };

  return (
    <div className={`imageUploadWrapper ${disabled ? "disable" : ""}`}>
      <input
        type="file"
        ref={fileInputRef}
        accept="image/"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <div
        className="handleDivClickWrapper"
        style={{
          width: "500px",
          height: "250px",
          border: !isRenderCustom && "2px dashed #ccc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          opacity: isDisabled ? 0.8 : 1,
        }}
        onClick={() => {
          !cropStarted && handleDivClick();
        }}
      >
        {errorMsg && (
          <div
            className="alert alert-danger"
            role="alert"
            style={{ position: "absolute" }}
          >
            {errorMsg}
          </div>
        )}
        {needCrop && imageSrc ? (
          <div className="imageCropWrapper">
            <div
              className="imageCropperItemWrapper"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ReactCrop
                crop={crop}
                onChange={(newCrop) => {
                  setCropStarted(true);
                  setCrop(newCrop);
                }}
                onComplete={getCroppedImage}
                keepSelection={false}
              >
                <img
                  src={imageSrc}
                  alt="Crop"
                  height="240px"
                  crossOrigin="anonymous"
                  width="240px"
                  onLoad={(e) => {
                    onImageLoad(e.target);
                  }}
                />
              </ReactCrop>
            </div>
            <div
              className="choseBtnWrapper"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  marginTop: "14px",
                }}
              >
                Crop your image. Only highlighted area will be visible.
              </div>
              <div
                className="saveBtn"
                style={{ width: "250px" }}
                onClick={() => {
                  setCropStarted(false);
                  setImageSrc("");
                  setIsDisabled(false);
                  fileInputRef.current.click();
                }}
              >
                Choose Photo
              </div>
            </div>
          </div>
        ) : (
          <div>
            {isRenderCustom ? <> {renderCustom()}</> : "Click to Upload Image"}
          </div>
        )}
      </div>
    </div>
  );
};
export default ImageCropper;
